import type { Car } from '@multirx/shared';
import { resolveCar3dModelUrl } from '../cars/car3dModelMap.js';

export type FeaturedCarCardModel = {
  carId: number;
  name: string;
  modelUrl: string;
};

function escapeHtml(s: string): string {
  const div = document.createElement('div');
  div.textContent = s;
  return div.innerHTML;
}

export function buildFeaturedCarCardModel(car: Car): FeaturedCarCardModel {
  return {
    carId: car.id ?? 0,
    name: car.name?.trim() || 'Voiture',
    modelUrl: resolveCar3dModelUrl(car),
  };
}

/** Tuile x1 : titre + nom voiture + 3D absolute solo à droite. */
export function featuredCarCardInnerHtml(model: FeaturedCarCardModel): string {
  return `
    <p class="heading">Voitures</p>
    <p class="featured-car-subtitle">${escapeHtml(model.name)}</p>
    <p class="featured-car-cta">Explorer →</p>
    <div class="featured-car-media" aria-hidden="true">
      <div class="featured-car-stage" data-featured-car-3d></div>
    </div>`;
}
